import openErrorBannerAction from 'modules/banner/actions/open-error'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import { saveReduxService } from 'modules/redux/services'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import { loadErrorLegacyReduxAction, loadingLegacyReduxAction, loadSuccessLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import { createReduxUtil } from 'modules/redux/utils/legacy/create'

/**
 * Creates an instance and put it into the store.
 * @param  {Object} params
 *         {string} endpoint
 *         {string} className
 *         {string} domainListPath
 *         {Object} data
 *         {Object} [options={}]
 *         {Object} options[APP_OPTION.JWT]
 * @returns {Function}
 */
function createRemoteInstanceLegacyRedux (params) {
  return dispatch => {
    const {
      endpoint,
      className,
      domainListPath,
      data,
      options = {}
    } = params
    // Create the instance
    const value = createReduxUtil(className)
    const path = getPathReduxUtil(value)
    dispatch(
      updateLegacyReduxAction({
        path,
        value
      })
    )
    // Mark the Instance and DomainList as loading
    dispatch(
      loadingLegacyReduxAction({
        path,
        className,
        domainListPath,
        options
      })
    )
    return saveReduxService(endpoint, data, options)
      .then(data => {
        dispatch(
          loadSuccessLegacyReduxAction({
            path,
            data,
            className,
            domainListPath,
            options
          })
        )
        return data
      })
      .catch(error => {
        dispatch(
          loadErrorLegacyReduxAction({
            path,
            error,
            options,
            domainListPath
          })
        )
        dispatch(
          openErrorBannerAction(error)
        )
        // assume action create catch errors
        throw error
      })
  }
}

export {
  createRemoteInstanceLegacyRedux
}
